import React from 'react';

import ConfirmDialog from 'components/confirm-dialog';
import { t } from 'state/intl/translations';

import { BodyComponent } from '../body-component';

interface IPickerAspectsUpdateDialog {
  showDialog: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const PickerAspectsUpdateDialog = ({
  showDialog,
  onConfirm,
  onCancel,
}: IPickerAspectsUpdateDialog) => {
  const heading = t('productDetailResetHeading');
  const content = t('productDetailResetContent');

  const confirmLabel = t('reset');
  const cancelLabel = t('discard');

  return showDialog ? (
    <ConfirmDialog
      showDialog={showDialog}
      modalAppearanceEventMessage="Confirmation: Picker Aspect will Reset Customizations to Default"
      bodyComponent={<BodyComponent heading={heading} content={content} />}
      confirmLabel={confirmLabel}
      cancelLabel={cancelLabel}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  ) : null;
};
